import React, { Component } from 'react'
import { Module, Row } from 'components/misc'
import { Form, Title } from 'components/layout'
import { FormattedMessage, injectIntl } from 'react-intl'
import styles from './new-pages.styl'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { get } from 'lodash'


@injectIntl
class NewPages extends Component {
  static propTypes = {
    links: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired
  }

  render() {

    const { intl, links } = this.props

    return (
      <div className={styles.module_wrapper}>
        <Module verticallyNarrow primary>
          <div className={styles.wrapper}>
            <Row alignItems="center" gutters inner paddingTop>
              <Form>
                <Title h1>
                  <FormattedMessage
                    id="moduleTitle.new_pages"
                    defaultMessage="New Pages"
                  />
                </Title>

                <div className={styles.desc}>
                  <FormattedMessage
                    id="label.new_pages_desc"
                    defaultMessage="This Preview tab is designed for testing newly developed features intended for the ORB."
                  />
                </div>

                <ul className={styles.list}>
                  {links.map(item => {
                    const linkMessage = intl.formatMessage({
                      id: item.message,
                      defaultMessage: item.defaultMessage
                    })

                    return (
                      <li
                        className={styles.item}
                        key={item.id}
                      >
                        <div className={styles.itemContainer}>
                        <div className={styles.linkWrapper}>
                        <NavLink
                          to={item.url}
                          className={styles.link}
                        >
                          <class className={`ico ico--${item.icon} ${styles.icon}`} data-tip={linkMessage} />
                          <span className={`${styles.itemTitle}`}>
                            {linkMessage}
                          </span>
                        </NavLink>
                        </div>
                        <div className={styles.descWrapper}>
                        {get(item, 'description')}
                        </div>
                        </div>
                      </li>
                    )
                  })}
                </ul>
              </Form>
            </Row>
          </div>
        </Module>
      </div>
    )
  }
}

export default NewPages
